export default __webpack_public_path__ + "static/media/rivier.792bc66d.jpg";